// One component per step kind; `branch` and `repeat` have no screen (the
// machine passes through them), the rest of the screen-less kinds only show
// when they stopped.

import type { ReactElement } from 'react'
import type { WizardStepKind } from '../contract'
import ActionStep from './ActionStep'
import AutoStep from './AutoStep'
import CallStep from './CallStep'
import ConfirmStep from './ConfirmStep'
import FetchUrlStep from './FetchUrlStep'
import GridStep from './GridStep'
import HandoffStep from './HandoffStep'
import InfoStep from './InfoStep'
import InputStep from './InputStep'
import LoadStep from './LoadStep'
import PollStep from './PollStep'
import PrintStep from './PrintStep'
import RedirectStep from './RedirectStep'
import SaveStep from './SaveStep'
import SendStep from './SendStep'
import SignStep from './SignStep'
import ScanStep from './ScanStep'
import SelectStep from './SelectStep'
import ShowStep from './ShowStep'
import type { StepProps } from './common'

const BY_KIND: Partial<Record<WizardStepKind, (p: StepProps) => ReactElement | null>> = {
  info: InfoStep,
  select: SelectStep,
  input: InputStep,
  scan: ScanStep,
  grid: GridStep,
  confirm: ConfirmStep,
  show: ShowStep,
  print: PrintStep,
  sign: SignStep,
  send: SendStep,
  call: CallStep,
  auto: AutoStep,
  action: ActionStep,
  fetch_url: FetchUrlStep,
  redirect: RedirectStep,
  function: PollStep,
  load: LoadStep,
  save: SaveStep,
  handoff: HandoffStep,
}

export default function StepBody(props: StepProps) {
  const kind = props.ctl.step?.kind
  const C = (kind && BY_KIND[kind]) || AutoStep
  return <C {...props} />
}

export { default as StartStep } from './StartStep'
export type { StepProps } from './common'
